export default __webpack_public_path__ + "static/media/profile.002cdb3f.png";